import { useContext } from 'react'

import AppContext from '@/context/AppContext'

const useReturnLabels = () => {
  const { context, setContext } = useContext(AppContext)

  const changeNumberOfReturnLabels = number => {
    setContext(context => {
      return {
        ...context,
        orderInfo: { ...context.orderInfo, numberOfReturnLabels: number },
      }
    })
  }

  const resetNumberOfReturnLabels = () => {
    setContext(context => {
      return {
        ...context,
        orderInfo: { ...context.orderInfo, numberOfReturnLabels: 1 },
      }
    })
  }

  return {
    numberOfReturnLabels: context.orderInfo.numberOfReturnLabels,
    maxNumberOfReturnLabels: context?.items?.length,
    changeNumberOfReturnLabels,
    resetNumberOfReturnLabels,
  }
}

export default useReturnLabels
